import { API_AUTOSTATS_URL } from "@/configs/global";
import { IParamsObject, IServerResponse } from "@/api/types";
import { axiosInstance } from "@/api/index";
import { AxiosResponse } from "axios";
import { IPostback } from "@/api/types/autostats";
import { FormattedItem } from "@/utils/CellsFromBff";
import { PostbackError } from "@crm-ui/types";

/* Получение постбеков */
export async function getPostbacks(params: IParamsObject, isExport?: boolean): Promise<IServerResponse<IPostback[]>> {
    const responseType = isExport ? 'blob' : 'json';
    const headers = isExport ? { 'accept': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" } : {};
    return axiosInstance.request<IServerResponse<IPostback[]>>({
        method: 'GET',
        url: `${API_AUTOSTATS_URL}/employees/postbacks`,
        params,
        headers,
        responseType,
    })
        .then((response: AxiosResponse<IServerResponse<IPostback[]>>) => response.data);
}

/* Получение одного постбека */
export async function getPostback(
    id: string | number,
    params?: IParamsObject,
): Promise<IServerResponse<IPostback>> {
    return axiosInstance.request<IServerResponse<IPostback>>({
        method: 'GET',
        url: `${API_AUTOSTATS_URL}/employees/postbacks/${id}`,
        params: {
            ...params,
        },
    })
        .then((response: AxiosResponse<IServerResponse<IPostback>>) => response.data);
}

type PostbackErrorsBff = IServerResponse<FormattedItem<PostbackError>[]>;

export async function getPostbackErrors(params: IParamsObject): Promise<PostbackErrorsBff> {
    return axiosInstance.request<PostbackErrorsBff>({
        method: 'GET',
        url: `${API_AUTOSTATS_URL}/employees/postbacks-errors`,
        params,
    }).then((response: AxiosResponse<PostbackErrorsBff>) => response.data);
}

export async function exportPostbackErrors(params: IParamsObject): Promise<Blob> {
    return axiosInstance.request<Blob>({
        method: 'GET',
        url: `${API_AUTOSTATS_URL}/employees/postbacks-errors`,
        headers: { Accept: 'text/csv' },
        responseType: 'blob',
        params,
    }).then((response) => response.data);
}

export interface PostbackErrorType {
    error_type: string;
    error_label: string;
}

export async function getPostbackErrorTypes(): Promise<PostbackErrorType[]> {
    return axiosInstance.request<IServerResponse<PostbackErrorType[]>>({
        method: 'GET',
        url: `${API_AUTOSTATS_URL}/employees/postbacks-errors/types`,
    }).then((response: AxiosResponse<IServerResponse<PostbackErrorType[]>>) => response.data.data);
}

export async function getPostbackErrorChart(params: any): Promise<any[]> {
    return axiosInstance.request<IServerResponse<any[]>>({
        method: 'GET',
        url: `${API_AUTOSTATS_URL}/employees/postbacks-errors/by-day`,
        params,
    })
        .then((response: AxiosResponse<IServerResponse<any[]>>) => response.data.data);
}
